import { useVivliConfigContext } from '@vivli/core/infrastructure/context';

export const DefaultBasicDataPackageListComponent = () => {
    const vivliConfig = useVivliConfigContext();
    return (
        <ul>
            {vivliConfig?.ipdFileTypes
                ?.filter((x) => x.requiredCtBasic)
                .map((x, i) => (
                    <li key={i}>{x.displayName}</li>
                ))}
        </ul>
    );
};
